import {inject, Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs';
import {PageResponse} from '../../../shared/commons/page-response';

export interface DepartmentDto {
  id?: number;
  departmentCode?: string;
  nameTh?: string;
  nameEn?: string;
  taxid?: string;
  address?: string;
  province?: number;
  district?: number;
  subdistrict?: number;
  zipcode?: string;
  telephone?: string;
  fax?: string;
  lat?: string;
  lng?: string;
  ordering?: number;
  state?: number;
  checkedOut?: number;
  checkedOutTime?: string;
  createdDate?: string;
  modifiedDate?: string;
  modifiedApiDate?: string;
  createdName?: string;
  lastUpdatedName?: string;
}

export interface ProvinceDto {
  id?: number;
  code?: string;
  title?: string;
  titleEn?: string;
  ordering?: number;
  state?: number;
}

export interface DistrictDto {
  id?: number;
  code?: string;
  title?: string;
  titleEn?: string;
  province?: ProvinceDto;
  ordering?: number;
  state?: number;
}

export interface SubDistrictDto {
  id?: number;
  code?: string;
  title?: string;
  titleEn?: string;
  district?: DistrictDto;
  province?: ProvinceDto;
  ordering?: number;
  state?: number;
}

@Injectable({providedIn: 'root'})
export class DepartmentService {
  private readonly http = inject(HttpClient);
  private readonly apiUrl = '/api/master/departments';

  search(params: HttpParams): Observable<PageResponse<DepartmentDto>> {
    return this.http.get<PageResponse<DepartmentDto>>(this.apiUrl, {params});
  }

  getActiveDepartments(): Observable<DepartmentDto[]> {
    return this.http.get<DepartmentDto[]>(`${this.apiUrl}/active`);
  }

  getDepartmentById(id: number): Observable<DepartmentDto> {
    return this.http.get<DepartmentDto>(`${this.apiUrl}/${id}`);
  }

  createDepartment(department: DepartmentDto): Observable<DepartmentDto> {
    return this.http.post<DepartmentDto>(this.apiUrl, department);
  }

  updateDepartment(id: number, department: DepartmentDto): Observable<DepartmentDto> {
    return this.http.put<DepartmentDto>(`${this.apiUrl}/${id}`, department);
  }

  deleteDepartment(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`);
  }

  checkTaxid(taxid: string, excludeId?: number): Observable<boolean> {
    let params = new HttpParams();
    if (excludeId != null) {
      params = params.set('excludeId', excludeId);
    }
    return this.http.get<boolean>(`${this.apiUrl}/check-taxid/${taxid}`, {params});
  }
}
